import CollectionBase from 'common/base/collection-base';
import PointsModel from 'common/models/points-model';
import {t} from 'common/utils/translation-util';

export default CollectionBase.extend({
  getPoint(systemName) {
    const points = this.getPoints();
    for (let ii = 0, nn = points.length; ii < nn; ii++) {
      const point = points[ii];
      if (point.systemName === systemName) {
        return point;
      }
    }
  },

  getPoints() {
    if (this.models) {
      // JSON provided directly, did not fetch
      const points = [];
      for (let ii = 0, nn = this.models.length; ii < nn; ii++) {
        points.push(this.models[ii].attributes);
      }
      return points;
    }
    return this.getAttribute('points');
  },

  initialize() {
    this.errorMessage = t('Point data failed to load.');
    this.model = PointsModel;
  },
});
